import React from 'react';
import classNames from 'styles/utils/classNames';

interface CertificationSelectProps {
  onClick: () => void;
  imgSrc: string;
  title: string;
  isSelected: boolean;
}

const CertificationSelect: React.FC<CertificationSelectProps> = ({
  onClick,
  imgSrc,
  title,
  isSelected,
}) => {
  const selectedShadow =
    'shadow-[0px_0px_0px_2px_#FFF,_0px_0px_0px_3px_#B9B9BE,_0px_4px_20px_0px_rgba(0,0,0,0.16)]';

  return (
    <div className="flex max-w-[8rem] flex-col items-center gap-1" onClick={onClick} role="button">
      <div
        className={classNames(
          'flex w-full items-center justify-center rounded-xl border border-transparent px-6 py-5 transition-all',
          isSelected
            ? '!border-color-border-card-lightmode dark:!border-color-border-card-darkmode'
            : 'bg-color-bg-lightmode-secondary dark:bg-color-bg-darkmode-secondary',
          isSelected && selectedShadow,
        )}
      >
        <img
          src={imgSrc}
          alt="certification-logo"
          className={classNames(
            'h-auto max-w-10',
            !isSelected && 'grayscale',
            isSelected && 'drop-shadow-[0px_5px_20px_rgba(0,0,0,0.40)]',
          )}
        />
      </div>
      <span className="typography-product-element-label mt-1">{title}</span>
    </div>
  );
};

export default CertificationSelect;
